import { stat } from "fs"
export default {
    // namespace:true,
    state:{
        nowitem:{
            xixi:'xixi',
            prjname:{
                name:'',
                directory:{
                    name:'',
                    detail:{
                        name:''
                    }
                },
            }
        },
        comparearr:[]
    },
    gutters:{
        comparearrgutter(state){
            return state.comparearr
        }
    },
    mutations:{
        compareitempush(state,item){
            state.comparearr.push(item)
        },
        compareitemchange(state,item){
            state.comparearr=item
        },
        changeprj(state,newprj){
            state.nowitem={
                    prjname:{
                        name:newprj,
                        directory:{}
                    },
                }
        },
        changehol({nowitem},newhol){
            nowitem.prjname.directory={
                name:newhol,
                detail:{
                    
                }
            }
        },
        changedetail({nowitem},newdetail){
            nowitem.prjname.directory.detail={
                detail:{
                    name:newdetail,
                }
            }
        }
    },
    actions:{
    }
}